<kt-portlet class="knostos-grid">
  <kt-portlet-header [class]="'card-head-lg'">
    <!-- PORTLET LOADING | Binded to TABLE Datasource -->

    <ng-container ktPortletTitle>
      <span translate="PATIENT_DEVICE.LIST_TITLE">Patient Device List</span>
    </ng-container>
    <ng-container ktPortletTools>
      <div *ngIf="!isReadOnly">
        <ng-template ngxPermissionsOnly="canAddDeviceInventory">
          <button mat-raised-button color="primary" (click)="assignDevice()">
            <span class="svg-icon-md" translate>
              <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
              Assign Device
            </span>
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>
  <!-- end::Header -->

  <kt-portlet-body>
    <!-- MATERIAL TABLE | Binded to datasources -->
    <div class="mat-table-wrapper">
      <mat-table class="lmat-elevation-z8" [dataSource]="dataSource">
        <!-- Checkbox Column -->

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef translate="PATIENT_DEVICE.TABLE.NAME"
            >Name</mat-header-cell
          >
          <mat-cell
            *matCellDef="let patientDevice"
            class="clickable"
            (dblclick)="viewPatientDevice(patientDevice)"
            >{{ patientDevice.device_name }}</mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="serial_id">
          <mat-header-cell *matHeaderCellDef translate="PATIENT_DEVICE.TABLE.SERIAL_ID"
            >Serial ID</mat-header-cell
          >
          <mat-cell *matCellDef="let patientDevice">{{ patientDevice.serial_id }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="date_last_sync">
          <mat-header-cell *matHeaderCellDef translate="PATIENT_DEVICE.TABLE.DATE_LAST_SYNC"
            >Date Last Synced</mat-header-cell
          >
          <mat-cell *matCellDef="let patientDevice">{{ patientDevice.date_last_sync }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="last_battery_value">
          <mat-header-cell *matHeaderCellDef translate="PATIENT_DEVICE.TABLE.LAST_BATTERY_VALUE"
            >Last Battery Value</mat-header-cell
          >
          <mat-cell *matCellDef="let patientDevice">{{
            patientDevice.last_battery_value
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="alerts">
          <mat-header-cell *matHeaderCellDef translate="PATIENT_DEVICE.TABLE.ALERTS"
            >Alerts</mat-header-cell
          >
          <mat-cell *matCellDef="let patientDevice">
            <span *ngIf="!patientDeviceHasAlerts(patientDevice.alerts)">No Alerts</span>
            <span *ngIf="patientDeviceHasAlerts(patientDevice.alerts)">
              <i
                class="material-icons"
                [matTooltip]="getAlertsString(patientDevice.alerts)"
                matTooltipPosition="right"
                [matTooltipClass]="'tooltipNewLine'"
                [ngStyle]="{ color: '#ff3300' }"
              >
                warning
              </i>
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="view">
          <mat-header-cell *matHeaderCellDef translate="PATIENT_DEVICE.TABLE.VIEW"
            >View</mat-header-cell
          >
          <mat-cell *matCellDef="let patientDevice">
            <button
              color="success"
              matTooltip="View Patient Device"
              (click)="viewPatientDevice(patientDevice)"
              class="btn btn-icon btn-light btn-hover-success btn-sm"
            >
              <span class="svg-icon svg-icon-md svg-icon-success">
                <span inlineSVG="./assets/media/svg/icons/General/visible.svg"></span>
              </span>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <!-- Message for empty data  -->
      <div
        class="mat-table-message"
        *ngIf="dataSource?.data?.length < 1 && !loading"
        translate="GLOBAL.NO_RECORDS_FOUND"
      >
        No Records Found
      </div>
    </div>
  </kt-portlet-body>
  <!-- end::Body -->
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
